import { useQuery } from '@tanstack/react-query';
import { type ILayoutTag } from 'src/interfaces/LayoutTag';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetAllLayoutTags = (filters: string[] = [], enabled = true) =>
  useQuery({
    queryKey: queryKeys.layoutTags.all(filters),
    queryFn: () => fetchLayoutTags(filters),
    staleTime: Infinity,
    enabled,
  });

const fetchLayoutTags = async (filters: string[] = []) => {
  const response = await requestCCApi({
    url: `/layoutTags${generateQuery([], [...filters, 'pageSize=20'])}`,
  });

  return response.data as ILayoutTag[];
};
